import {
  outboundAttachmentUploadResponseSchema,
  outboundMediaCapabilitiesResponseSchema,
  type OutboundAttachmentUploadResponse,
  type OutboundMediaCapabilitiesResponse,
} from "@multi-chat/shared";
import { apiDelete, apiGet, apiPostFormData } from "./client.js";

function conversationBase(organizationId: number, conversationId: number): string {
  return `/organizations/${organizationId}/conversations/${conversationId}`;
}

export async function getOutboundMediaCapabilities(
  organizationId: number,
  conversationId: number,
  signal?: AbortSignal,
): Promise<OutboundMediaCapabilitiesResponse> {
  return outboundMediaCapabilitiesResponseSchema.parse(
    await apiGet(
      `${conversationBase(organizationId, conversationId)}/outbound-media-capabilities`,
      signal,
    ),
  );
}

export async function cancelConversationAttachment(
  organizationId: number,
  conversationId: number,
  attachmentId: string,
  signal?: AbortSignal,
): Promise<{ cancelled: boolean }> {
  return apiDelete<{ cancelled: boolean }>(
    `${conversationBase(organizationId, conversationId)}/attachments/${attachmentId}`,
    signal,
  );
}

export async function uploadConversationAttachment(
  organizationId: number,
  conversationId: number,
  file: File,
  signal?: AbortSignal,
  options?: { recordedVoice?: boolean; recordedVoiceDurationMs?: number },
): Promise<OutboundAttachmentUploadResponse> {
  const formData = new FormData();
  formData.append("fileSizeBytes", String(file.size));
  if (options?.recordedVoice) {
    formData.append("recordedVoice", "true");
    if (
      options.recordedVoiceDurationMs != null &&
      Number.isFinite(options.recordedVoiceDurationMs) &&
      options.recordedVoiceDurationMs > 0
    ) {
      formData.append("recordedVoiceDurationMs", String(Math.round(options.recordedVoiceDurationMs)));
    }
  }
  formData.append("file", file, file.name);
  return outboundAttachmentUploadResponseSchema.parse(
    await apiPostFormData(
      `${conversationBase(organizationId, conversationId)}/attachments`,
      formData,
      signal,
    ),
  );
}
